const BetssonBrandIds = Object.freeze({
  11: 'Betsson Native',
  15: 'BetssonDk',
  17: 'Betsafe',
  21: 'Starcasino',
  22: 'NordicBetDK',
  23: 'NordicBet',
  30: 'JallaCasino',
  36: 'BetssonES',
  41: 'Betsson.GR',
  42: 'BetssonArBaCity',
  43: 'BetssonArBa',
  46: 'BetssonMx',
  57: 'BetssonBr',
  62: 'BetssonBeCasino',
  63: 'BetssonBeSportsbook'
})

export { BetssonBrandIds }



// WEBPACK FOOTER //
// ./src/modules/integrations/types/betsson/BetssonBrandIdEnum.js